import dashboard from './dashboard';
import communitypages from './communitypages';
// import pages from './pages';
import setup from './setup'

//import utilities from './utilities';

const menuItems = {
  items: [dashboard, communitypages, setup]
};

export default menuItems;

